
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class AuthService extends BaseApi {


    constructor(){
        super();
    }
 
    /**
     * LOGIN
     * @param {string} email user's email
     * @param {string} password user's password
     */
    async login(email, password)
    {
        return this.http.post(`${this.baseUrl}/login`,{
            email: email,
            password: password,
            remember_me: true,
        })
        .catch(this.handleErrorResponse);
    }


    async me()
    {
        return this.http.get(`${this.baseUrl}/user`)
        .catch(this.handleErrorResponse);
    }


}